var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "button",
        {
          ref: "hamburger",
          staticClass: "hamburger",
          on: { click: _vm.toggle },
        },
        [
          _c("img", {
            attrs: {
              src: "/wp-content/themes/svea/resources/assets/images/hamburger.svg",
              alt: "",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.opened,
                expression: "opened",
              },
            ],
            staticClass: "menu__modal",
          },
          [
            _c("div", { staticClass: "menu__wrapper" }, [
              _c("div", { staticClass: "menu__header" }, [
                _c("div", { staticClass: "menu__info" }, [
                  _vm.opening && _vm.title
                    ? _c("p", { staticClass: "menu__info-hours" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.title) +
                            "\n              "
                        ),
                        _c("strong", {
                          domProps: { innerHTML: _vm._s(_vm.opening) },
                        }),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "menu__info-phone" }, [
                    _vm._v("\n              Telefon:\n              "),
                    _c("strong", [_vm._v("08-669 78 00")]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    ref: "close",
                    staticClass: "menu__close",
                    on: { click: _vm.toggle },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 24 24",
                          fill: "#31433c",
                        },
                      },
                      [
                        _c("path", {
                          attrs: { fill: "none", d: "M0 0h24v24H0z" },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "menu__content",
                domProps: { innerHTML: _vm._s(_vm.menu) },
              }),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/Menu.vue